<template>
  <div>
    <nav
      class="navbar navbar-expand-lg navbar-light fixed-top p-st"
      :class="{
        'bg-light': !nightMode,
        'navbar-blur': navbarConfig.blur,
        'bg-dark2': nightMode,
      }"
    >
      <div class="container">
        <a
          class="navbar-brand"
          href="/"
          @click.prevent="$emit('scroll', 'home')"
        >
          <Logo :nightMode="nightMode" />
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span style="color: gray; font-size: 23px;"
            ><i class="fas fa-bars"></i
          ></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto">

            <li class="nav-item mx-2">
              <a
                class="nav-link"
                href="/"
                @click.prevent="$emit('scroll', 'home')"
                :class="{ 'text-light': nightMode }"
                >About me</a
              >
            </li>

            <li class="nav-item mx-2">
              <a
                class="nav-link"
                href="/journey"
                @click.prevent="$emit('scroll', 'journey')"
                :class="{ 'text-light': nightMode }"
                >Journey</a
              >
            </li>
            
            <li class="nav-item mx-2">
              <a
                class="nav-link"
                href="/expertise"
                @click.prevent="$emit('scroll', 'expertise')"
                :class="{ 'text-light': nightMode }"
                >Expertise</a
              >
            </li>

            <li class="nav-item mx-2 ">
              <a
                class="nav-link"
                href="/certifications"
                @click.prevent="$emit('scroll', 'certificate')"
                :class="{ 'text-light': nightMode }"
                >Certifications</a
              >
            </li>

            <li class="nav-item mx-2">
              <a
                class="nav-link"
                href="/recommendation"
                @click.prevent="$emit('scroll', 'recommendation')"
                :class="{ 'text-light': nightMode }"
                >Recommendations</a
              >
            </li>


            <li class="nav-item mx-2">
              <a
                class="nav-link"
                href="/contact"
                @click.prevent="$emit('scroll', 'contact')"
                :class="{ 'text-light': nightMode }"
                >Contact</a
              >
            </li>

            <li class="nav-item ml-2">
              <a
                class="nav-link"
                href="#"
                @click.prevent="switchMode"
                :class="{ 'text-light': nightMode }"
                ><i
                  :class="{
                    'fas fa-moon': nightMode,
                    'far fa-moon': !nightMode,
                  }"
                  v-tooltip.bottom="nightMode ? 'Light Mode' : 'Night Mode'"
                ></i
              ></a>
            </li>


          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import Logo from "./helpers/Logo";
import info from "../../info";

export default {
  name: "Navbar",
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      navbarConfig: info.config.navbar,
      localNightMode: this.nightMode,
    };
  },
  components: {
    Logo,
  },
  methods: {
    switchMode() {
      this.localNightMode = !this.localNightMode;
      this.$emit("nightMode", this.localNightMode);
    },
  },
};
</script>

<style scoped>
.nav-link {
  font-weight: 500;
}

button {
  border: none;
  outline: none;
}

button:hover {
  border: none;
  outline: none;
}

nav {
  border-bottom: 1px solid rgba(160, 159, 159, 0.336);
  position: fixed !important;
  font-style: italic;
}

.navbar-blur {
  background-color: #ffffff7e;
  backdrop-filter: blur(12px);
}
</style>
